import type { SVGProps } from 'react';
const DawnFlagPA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-PA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-PA_svg__a)">
      <path fill="#E52448" d="M22 7.467H10.477V0H22z" />
      <path
        fill="#1367AE"
        d="M10.476 16H0V7.467h10.476zM5.238 4.608l-1.232.851.415-1.455-1.176-.93 1.488-.048.505-1.426.505 1.426 1.488.048-1.176.93.414 1.455z"
      />
      <path
        fill="#E52448"
        d="m16.238 12.608-1.232.851.415-1.455-1.176-.93 1.488-.048.505-1.426.505 1.426 1.488.048-1.176.93.414 1.455z"
      />
    </g>
  </svg>
);
export default DawnFlagPA;
